import { TableCell, TableFooter, TableRow } from "@/components/ui/table";
import { CostData } from "@/types/project";
import { formatCurrency } from "@/utils/format";

interface CostTableFooterProps {
  costs: CostData;
}

export function CostTableFooter({ costs }: CostTableFooterProps) {
  const costComponents = [
    "labour",
    "materials",
    "overheads",
    "plant",
    "staff",
    "subcontractor",
  ] as const;

  const totals = costComponents.reduce(
    (acc, key) => ({
      toDate: acc.toDate + (costs[key]?.toDate || 0),
      forecast: acc.forecast + (costs[key]?.forecast || 0),
      budgeted: acc.budgeted + (costs[key]?.budgeted || 0),
    }),
    { toDate: 0, forecast: 0, budgeted: 0 }
  );

  const anticipatedFinal = totals.toDate + totals.forecast;
  const variance = totals.budgeted - anticipatedFinal;
  const isOverBudget = variance < 0;

  return (
    <TableFooter>
      <TableRow className="bg-muted/50 font-medium text-base">
        <TableCell>Total</TableCell>
        <TableCell className="text-right">
          {formatCurrency(totals.budgeted)}
        </TableCell>
        <TableCell className="text-right">
          {formatCurrency(totals.toDate)}
        </TableCell>
        <TableCell className="text-right">
          {formatCurrency(totals.forecast)}
        </TableCell>
        <TableCell className="text-right">
          {formatCurrency(anticipatedFinal)}
        </TableCell>
        <TableCell className="text-right">
          <span
            className={
              isOverBudget ? "text-destructive font-semibold" : "text-green-600 font-semibold"
            }
          >
            {formatCurrency(Math.abs(variance))}
            {isOverBudget ? " (Over)" : " (Under)"}
          </span>
        </TableCell>
        <TableCell></TableCell>
      </TableRow>
    </TableFooter>
  );
}
